var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.875C4 4.39175 4.39175 4 4.875 4H21.125C21.6082 4 22 4.39175 22 4.875C22 5.35825 21.6082 5.75 21.125 5.75H4.875C4.39175 5.75 4 5.35825 4 4.875ZM10 11C10 10.5168 10.3918 10.125 10.875 10.125H21.125C21.6082 10.125 22 10.5168 22 11C22 11.4832 21.6082 11.875 21.125 11.875H10.875C10.3918 11.875 10 11.4832 10 11ZM4 17.125C4 16.6418 4.39175 16.25 4.875 16.25H21.125C21.6082 16.25 22 16.6418 22 17.125C22 17.6082 21.6082 18 21.125 18H4.875C4.39175 18 4 17.6082 4 17.125Z",
    fill: "#060A33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon);
export default __webpack_public_path__ + "static/media/nav-icon.e10f4f69646e418dd35b463a1b3e6eaa.svg";
export { ForwardRef as ReactComponent };